<template>
  <vs-popup class="add-new-company-holiday"
            id="popup"
            title="CREATE QC TEST"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card v-if="!is_have_test_data">
      <vs-alert color="danger" active="false">
        There is no default test data for this raw material
      </vs-alert>
      <vs-button @click.stop="onClickAddDefaultTestData" class="ml-auto mt-4">Add default test data</vs-button>
    </vx-card>
    <vx-card no-shadow v-else>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateQcTest)" autocomplete="off">

          <vx-card subtitle="QC TEST" :cardBorder="true" no-shadow>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Test Type
                  </small>
                  <v-select :disabled="company_data.test_type || company_data.test_type.length > 0" :clearable="false" name="country" placeholder=""
                            label="name" v-model="form.test_type" :reduce="option => option.value"
                            :options="test_types" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="q_c_status" name="q_c_status" rules="" v-slot="{ errors }">
                  <small class="label">Status</small>
                  <v-select :clearable="true" name="q_c_status" placeholder="" v-model="form.q_c_status"
                            :options="['Approved', 'Rejected']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <!--        start  Odour_and_Appearance_Check-->
            <div class="vx-row mb-3" v-if="form.test_type === 'Odour_and_Appearance_Check'">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="o_a_check_odour" name="o_a_check_odour" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                  </small>
                  <vs-input v-model="form.o_a_check.odour"  name="o_a_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="o_a_check_appearance" name="o_a_check_appearance" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                  </small>
                  <vs-input v-model="form.o_a_check.appearance"  name="o_a_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
            <!--          end Odour_and_Appearance_Check-->

            <!--          start Taste_Odour_and_Appearance_Check-->
            <div class="vx-row mb-3" v-if="form.test_type === 'Taste_Odour_and_Appearance_Check'">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="t_o_a_check_taste" name="t_o_a_check_taste" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Taste <span v-if="company_data.taste" class="qc-test-guide-text">(Guide: {{ company_data.taste }})</span>
                  </small>
                  <vs-input v-model="form.t_o_a_check.taste"  name="t_o_a_check_taste" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="t_o_a_check_odour" name="t_o_a_check_odour" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                  </small>
                  <vs-input v-model="form.t_o_a_check.odour"  name="t_o_a_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3" v-if="form.test_type === 'Taste_Odour_and_Appearance_Check'">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider vid="t_o_a_check_appearance" name="t_o_a_check_appearance" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                  </small>
                  <vs-input v-model="form.t_o_a_check.appearance"  name="t_o_a_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
            <!--         end Taste_Odour_and_Appearance_Check-->

            <!--          start Odour_Appearance_SG_and_RI_Check-->
            <div class="vx-row mb-3" v-if="form.test_type === 'Odour_Appearance_SG_and_RI_Check'">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="o_a_s_r_check_odour" name="o_a_s_r_check_odour" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Odour <span v-if="company_data.odour" class="qc-test-guide-text">(Guide: {{ company_data.odour }})</span>
                  </small>
                  <vs-input v-model="form.o_a_s_r_check.odour"  name="o_a_s_r_check_odour" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="o_a_s_r_check_appearance" name="o_a_s_r_check_appearance" rules="required" v-slot="{ errors }">
                  <small class="label">
                    Appearance <span v-if="company_data.appearance" class="qc-test-guide-text">(Guide: {{ company_data.appearance }})</span>
                  </small>
                  <vs-input v-model="form.o_a_s_r_check.appearance"  name="o_a_s_r_check_appearance" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3" v-if="form.test_type === 'Odour_Appearance_SG_and_RI_Check'">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="s_g" name="s_g" rules="required" v-slot="{ errors }">
                  <small class="label">
                    SG  <span v-if="company_data.sg_from && company_data.sg_to" class="qc-test-guide-text">(Guide: {{ company_data.sg_from }} - {{ company_data.sg_to }})</span>
                  </small>
                  <vs-input v-model="form.o_a_s_r_check.s_g"  name="s_g" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="r_i" name="r_i" rules="required" v-slot="{ errors }">
                  <small class="label">
                    RI <span v-if="company_data.ri_from && company_data.ri_to" class="qc-test-guide-text">(Guide: {{ company_data.ri_from }} - {{ company_data.ri_to }})</span>
                  </small>
                  <vs-input v-model="form.o_a_s_r_check.r_i"  name="r_i" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="invoice_number" name="invoice_number" rules="" v-slot="{ errors }">
                  <small class="label">Invoice Number</small>
                  <vs-input v-model="form.invoice_number" name="invoice_number" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3" v-if="form.q_c_status == 'Rejected'">
              <div class="vx-col w-full">
                <ValidationProvider vid="batch_note" name="batch_note" rules="" v-slot="{ errors }">
                  <small class="label">Reason for Reject</small>
                  <vs-textarea class="mb-0" v-model="form.reason" height="70px"/>
                  <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="batch_note" name="batch_note" rules="" v-slot="{ errors }">
                  <small class="label">RM Batch Notes</small>
                  <vs-textarea class="mb-0" v-model="form.batch_note" height="70px"/>
                  <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                  <small class="label">QC Notes</small>
                  <vs-textarea class="mb-0" v-model="form.notes" height="70px"/>
                  <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="form = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const InventoryRepository = RepositoryFactory.get('inventory');
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  const SettingsRepository = RepositoryFactory.get('settings');

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";
  import {mapActions, mapGetters} from "vuex";

  function initialState() {
    return {
      open: false,
      id: '',
      is_have_test_data: true,
      stock_form: {
        manufacture_date: '',
        expiration_date: '',
        batch_no: '',
        company_product_code: '',
        category: '',
        quantity: '',
        supplier_batch_no: '',
      },
      shelf_location_r_options: [],
      shelf_location_s_options: [],
      shelf_location_l_options: [],
      form: {
        test_type:'',
        o_a_check: {
          odour: '',
          appearance: ''
        },
        t_o_a_check: {
          taste: '',
          odour: '',
          appearance: ''
        },
        o_a_s_r_check: {
          odour: '',
          appearance: '',
          s_g: '',
          r_i: '',
        },
        notes: '',
        q_c_status: '',
        quantity: '',
        invoice_number: '',
        batch_note: ''
      },
      isCreateMode: true,
      test_types: [
        {name: 'Do Not Sample', value: 'Do_Not_Sample'},
        {name: 'Odour and Appearance Check', value: 'Odour_and_Appearance_Check'},
        {name: 'Taste Odour and Appearance Check', value: 'Taste_Odour_and_Appearance_Check'},
        {name: 'Odour Appearance SG and RI Check', value: 'Odour_Appearance_SG_and_RI_Check'}
      ],
      raw_material_id: null,
      company_data: {},
      rm_item: {},
      inventoryItem: {}
    }
  }

  export default {
    name: 'AddQcTestRmOrderItemPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(rm_item, inventoryItem) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          this.id = rm_item.id
          this.rm_item = rm_item
          this.inventoryItem = inventoryItem
          this.raw_material_id = rm_item.raw_material_id 
          await this.fetchRmCompanyData()
          
        } catch (error) {
        }
      },
      async fetchRmCompanyData() {
        this.$vs.loading();
        try {
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialCompanyData(this.raw_material_id)).data
          this.company_data = data
          this.form.test_type = this.company_data.test_type
        } catch (e) {
          this.is_have_test_data = false
        }
        this.$vs.loading.close()
      },
      onClickAddDefaultTestData() {
        this.open = false
        this.$router.push(`/pages/raw-materials/${this.raw_material_id}?step=23`)
      },
      async onClickCreateQcTest() {
        this.$vs.loading();
        const vue = this;
        try {
          this.form.staff_raw_material_order_item_id = this.id
          this.form.quantity = this.inventoryItem.available_quantity
          this.form.raw_material_stock_inventory_id = this.inventoryItem.id
          let { data } = (await InventoryRepository.createOrderItemQcTest(this.form)).data          
          this.open = false
          await vue.$parent.refreshData();
          
        } catch (e) {
          this.$vs.loading.close();
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-company-holiday >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }
  .qc-test-guide-text {
    color: coral;
    font-weight: bold ;
    margin-left: 5px;
  }

</style>
